import { z } from 'zod';
import { FilterConfig_Author } from './filters/AuthorFilter';
import { FilterConfig_CatalogItems } from './filters/CatalogItemsFilter';
import { FilterConfig_Category } from './filters/CategoryFilter';
import { FilterConfig_ClearButton } from './filters/ClearButton';
import { FilterConfig_Date } from './filters/DateFilter';
import { FilterConfig_Hub } from './filters/HubFilter';
import { FilterConfig_HubGroup } from './filters/HubGroupFilter';
import { FilterConfig_HubTemplate } from './filters/HubTemplateFilter';
import { FilterConfig_MediaType } from './filters/MediaTypeFilter';
import { FilterConfig_MimeTypes } from './filters/MimeTypeFilter';
import { FilterConfig_MyZngly } from './filters/MyZnglyFilter';
import { FilterConfig_Order } from './filters/OrderFilter';
import { FilterConfig_Search } from './filters/SearchFilter';
import { FilterConfig_Tags } from './filters/TagsFilter';
import { FilterConfig_Visibility } from './filters/VisibilityFilter';
import { FilterConfig_ZnglistTemplate } from './filters/ZnglistTemplateFilter';

export const filterRegistry = Object.freeze({
  ...FilterConfig_Author,
  ...FilterConfig_Category,
  ...FilterConfig_MyZngly,
  ...FilterConfig_ClearButton,
  ...FilterConfig_Date,
  ...FilterConfig_Hub,
  ...FilterConfig_HubGroup,
  ...FilterConfig_HubTemplate,
  ...FilterConfig_MediaType,
  ...FilterConfig_Order,
  ...FilterConfig_Search,
  ...FilterConfig_Visibility,
  ...FilterConfig_Tags,
  ...FilterConfig_ZnglistTemplate,
  ...FilterConfig_MimeTypes,
  ...FilterConfig_CatalogItems,
} as const);

export type FilterRegistry = typeof filterRegistry;
export type FilterRegistryKeys = keyof FilterRegistry;

export const filterSchema = z.object({
  ...filterRegistry.author.searchSchema.shape,
  ...filterRegistry.category.searchSchema.shape,
  ...filterRegistry.myZngly.searchSchema.shape,
  ...filterRegistry.clearBtn.searchSchema.shape,
  ...filterRegistry.date.searchSchema.shape,
  ...filterRegistry.hubFilter.searchSchema.shape,
  ...filterRegistry.hubGroup.searchSchema.shape,
  ...filterRegistry.hubTemplate.searchSchema.shape,
  ...filterRegistry.mediaType.searchSchema.shape,
  ...filterRegistry.order.searchSchema.shape,
  ...filterRegistry.search.searchSchema.shape,
  ...filterRegistry.visibility.searchSchema.shape,
  ...filterRegistry.tags.searchSchema.shape,
  ...filterRegistry.znglistTemplate.searchSchema.shape,
  ...filterRegistry.mimeTypes.searchSchema.shape,
  ...filterRegistry.catalogItems.searchSchema.shape,
});

export type FilterSearchSchema = z.infer<typeof filterSchema>;
